(function (wpm, $, undefined) {

	wpm.getFormattedGA4Categories = function (productItems, categories) {

		let maxCategories = 5

		// remove categories with equal names from array
		categories = Array.from(new Set(categories))

		if (Array.isArray(categories) && categories.length) {

			productItems["item_category"] = categories[0]

			let max = categories.length > maxCategories ? maxCategories : categories.length

			for (let i = 1; i < max; i++) {
				productItems["item_category" + (i + 1)] = categories[i]
			}
		}

		return productItems
	}

	wpm.setGoogleCidOnServer = function () {

		try {

			let targetIDs = []

			if (wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) targetIDs.push(wpmDataLayer.pixels.google.analytics.ga4.measurement_id)
			if (wpmDataLayer?.pixels?.google?.analytics?.universal?.property_id) targetIDs.push(wpmDataLayer.pixels.google.analytics.universal.property_id)


			wpm.gtagLoaded().then(function () {
			    gtag("get", targetIDs[0], "client_id", (clientID) => {

    				// save the state in the database
    				let data = {
    					action: "wpm_google_analytics_set_session_data",
    					// 'nonce'    : wpm_google_premium_only_ajax_object.nonce,
    					// 'nonce'    : wpm.nonce,
    					target_ids: targetIDs,
    					client_id : clientID,
    					referrer  : wpm.getReferrerFromCookie(),
    					gclid     : wpm.getClidFromBrowser("gclid"),
    					// dclid    : wpm.getClidFromBrowser('dclid'),
    					userAgent     : wpm.getUserAgent(),
    					viewPortWidth : wpm.getViewPort().width,
    					viewPortHeight: wpm.getViewPort().height,
    				}

    				jQuery.ajax(
    					{
    						type    : "post",
    						dataType: "json",
    						// url     : wpm_google_premium_only_ajax_object.ajax_url,
    						url    : wpm.ajax_url,
    						data   : data,
    						success: function (response) {

    							if (response["success"] === true) {
    								if (window.sessionStorage) {
    									targetIDs.forEach((targetId) => {
    										window.sessionStorage.setItem('_wpm_ga_cid_set', JSON.stringify(true))
    										window.sessionStorage.setItem("wpm_cid_" + targetId + "_" + clientID + "_set", JSON.stringify(true))
    									})
    								} else {
    									targetIDs.forEach((targetId) => {
    										wpm.setCookie("wpm_cid_" + targetId + "_" + clientID + "_set", true)
    									})
    								}
    							}
    						},
    						error  : function (response) {
    							console.error(response)
    						},
    					})

    				// wp.ajax.post('wpm_google_analytics_set_session_data', data)
    				//     .done(function (response) {
    				//
    				//         // console.log(response);
    				//
    				//         if (response === 'success') {
    				//             if (window.sessionStorage) {
    				//                 // console.log('setting session storage');
    				//                 window.sessionStorage.setItem(cidSetOnServerCookie, JSON.stringify(true));
    				//             } else {
    				//                 // console.log('not setting session storage');
    				//
    				//                 wpm.setCookie(cidSetOnServerCookie, true);
    				//             }
    				//         }
    				//     })
    				//     .fail(function (response) {
    				//         console.log(response);
    				//     });
    			})
			})

		} catch (e) {
			console.error(e)
		}
	}

}(window.wpm = window.wpm || {}, jQuery))


jQuery(window).on("wpmLoadAlways", function () {

	try {
		if (
			wpmDataLayer?.pixels?.google?.analytics?.eec &&
			!window?.sessionStorage?.getItem('_wpm_ga_cid_set', JSON.parse(true)) &&
			(
				wpmDataLayer?.pixels?.google?.analytics?.universal?.property_id ||
				wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id
			)
		) {
			// We need to be sure that we capture the cid early enough, because the
			// shop might be using a one click checkout button as early as on the product page.
			if (["cart", "checkout"].indexOf(wpmDataLayer.shop.page_type) >= 0) {
				wpm.setGoogleCidOnServer()
			}
		}
	} catch (e) {
		console.error(e)
	}
})

